import { postApi } from './resonanceApi';
import { AxiosResponse } from 'axios';

// Define the email endpoint as a constant
const SEND_EMAIL_URL = 'email/send';

export const sendEmail = (body: {
  template: string;
  from?: string;
  to: string[];
  lang: string;
  params: Record<string, unknown>;
  studyId?: number;
}): Promise<AxiosResponse<{ message: string }>> => {
  return postApi(SEND_EMAIL_URL, {}, body);
};
